@let realSecuritiesBannerInputs = realSecuritiesBannerInputs$() | async;

@if (realSecuritiesBannerInputs.enabled && realSecuritiesBannerInputs.type.value !== REDIRECTION_TYPE.OFF) {
	<div class="rs-content">
		<p class="rs-title">{{ title() }}</p>
		<p class="rs-subtitle">{{ subtitle() }}</p>
		@if (
			realSecuritiesBannerInputs.type.value === REDIRECTION_TYPE.PLAN_A && realSecuritiesBannerInputs.linkExists
		) {
			<a class="rs-link" [href]="linkURL()">{{ linkTitle() }}</a>
		}
	</div>
}
